import React from 'react';
import PropTypes from 'prop-types';
import MaterialTextField from 'shared/components/connectedTextField/c/materialTextField/MaterialTextField';

const TTMetadata = ({ name, description, onValueChange, disabled }) => {
  const handleValueChange = (ev, value) => onValueChange(ev.target.name, value);
  return (
    <div>
      <div>
        <MaterialTextField
          name={ 'name' }
          label={ 'Name' }
          value={ name }
          onChange={ handleValueChange }
          fullWidth={ false }
          disabled={ disabled }
          required
        />
      </div>
      <div style={ { maxWidth: 650 } }>
        <MaterialTextField
          name={ 'description' }
          label={ 'Description (Optional)' }
          value={ description ? description : disabled ? ' ' : '' }
          onChange={ handleValueChange }
          disabled={ disabled }
        />
      </div>
    </div>
  );
};

TTMetadata.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onValueChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};

export default TTMetadata;



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/c/ttMetadata/TTMetadata.js